import type { ComponentProps, FC } from 'react';
import { useContext } from 'react';

import './tokens/base-colors/blue.css';
import './tokens/base-colors/clay.css';
import './tokens/base-colors/green.css';
import './tokens/base-colors/lime.css';
import './tokens/base-colors/ochre.css';
import './tokens/base-colors/purple.css';
import './tokens/base-colors/rose.css';
import './tokens/controls.css';
import './tokens/cursor.css';
import './tokens/diagram.css';
import './tokens/fonts.css';
import './tokens/radius.css';
import './tokens/semantic-colors/base.css';
import './tokens/semantic-colors/info.css';
import './tokens/semantic-colors/negative.css';
import './tokens/semantic-colors/neutral.css';
import './tokens/semantic-colors/notice.css';
import './tokens/semantic-colors/positive.css';
import './tokens/semantic-colors/syntax.css';
import './tokens/shadow.css';
import './tokens/space.css';
import './tokens/typography.css';

import { Slot } from '../slot/slot.tsx';

import { ThemeProviderNested } from './__provider-nested/theme__provider-nested.tsx';
import { ThemeProviderRoot } from './__provider-root/theme__provider-root.tsx';
import { cnTheme } from './theme.constants.js';
import { ThemeContext } from './theme.context.js';
import type { Appearance } from './theme.context.js';

import './theme.css';

export type { Appearance };

export type ThemeProps = ComponentProps<'div'> & {
    appearance?: Appearance;
    asChild?: boolean;
};

export const Theme: FC<ThemeProps> = ({ appearance, asChild, className, ...props }) => {
    const { isRoot } = useContext(ThemeContext);

    const Component = asChild ? Slot : 'div';
    const Provider = isRoot ? ThemeProviderRoot : ThemeProviderNested;

    return (
        <Provider appearance={appearance}>
            <Component {...props} className={cnTheme({}, [className])} />
        </Provider>
    );
};
